const baseUrl = (() => {
    return process.env.REACT_APP_BASE_API_URL;
  })();

export const paytmUrl = (() => {
    return process.env.REACT_APP_PAYTM_URL;
  })();
  
export default baseUrl;